import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import AlertTriangleIcon from "@redotech/redo-icons/alert-triangle.svg";
import { RedoBadge } from "@redotech/redo-web/arbiter-components/badge/redo-badge";
import { Flex } from "@redotech/redo-web/flex";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";
import { Tooltip } from "@redotech/redo-web/tooltip/tooltip";

const catalogEntry = fgColumnEntries["fraud-risk"];

function getRiskLevel(row: FulfillmentGroupData): string {
  if (!row.risk) {
    return "";
  }
  if (
    row.risk?.assessments.some((assessment) => assessment.riskLevel === "HIGH")
  ) {
    return "High";
  } else if (
    row.risk?.assessments.some(
      (assessment) => assessment.riskLevel === "MEDIUM",
    )
  ) {
    return "Medium";
  } else {
    return "";
  }
}

export const FraudRiskColumn: Column2<FulfillmentGroupData> = {
  alignment: ColumnAlignment.LEFT,
  key: catalogEntry.key,
  title: catalogEntry.title,
  renderNormalCell: ({ row }: { row: FulfillmentGroupData }) => {
    const riskFacts = row.risk?.assessments
      .flatMap((assessment) => assessment.facts.map((fact) => fact))
      .filter((fact) => fact?.sentiment === "NEGATIVE")
      .map((fact) => fact?.description)
      .join("\n");

    if (!row.risk) {
      return null;
    }

    const riskLevel = getRiskLevel(row);

    return (
      <Flex pl="lg">
        <Tooltip title={riskFacts}>
          <div>
            {riskLevel === "High" ? (
              <RedoBadge
                color="error"
                segmentLeading={{ type: "icon", Icon: AlertTriangleIcon }}
                size="xs"
                text={riskLevel}
              />
            ) : riskLevel === "Medium" ? (
              <RedoBadge color="warning" size="xs" text={riskLevel} />
            ) : null}
          </div>
        </Tooltip>
      </Flex>
    );
  },
  width: catalogEntry.defaultWidth,
};
